import type { SpatialRectangle } from "#public"

/** A box as its four edges. `y1` is the bottom and `y2` the top: y grows up,
 * like the plot API and the PDF it becomes. */
export const GetXY = <T extends number>({ x, y, width, height }: SpatialRectangle<T>) => ({
  x1: x,
  x2: (x + width) as T,
  y1: y,
  y2: (y + height) as T,
})
